import Vue from 'vue'

export default {
    storeDropdowns(state, dropdowns) {
        Vue.set(state, 'dropdowns', dropdowns)
    },
    storeDropdown(state, dropdown) {
        Vue.set(state, 'dropdown', dropdown)
    },
    storeSite(state, site) {
        Vue.set(state, 'site', site)
    },
    storeStaticSite(state, staticSite) {
        Vue.set(state, 'staticSite', staticSite)
    },
    storeSites(state, sites) {
        Vue.set(state, 'sites', sites)
    },
    storeSections(state, sections) {
        Vue.set(state, 'sections', sections)
    },
    clearSections(state) {
        Vue.set(state, 'sections', [])
    },
    clearSites(state) {
        Vue.set(state, 'sites', [])
    },
    storeSection(state, section) {
        if (section.type === "files" || section.type === "slider") {
            section.content = JSON.parse(section.content)
            section.content = section.content.filter(function (el) {
                return el != null;
            });
            if (section.content.some(x => x.id === null)) {
                let files = []
                for (let index = 0; index < section.content.length; index++) {
                    let file = section.content[index]
                    file.id = index
                    files[index] = file
                }
                section.content = files
            }
        }
        Vue.set(state, 'section', section)
    },
    clearSection(state) {
        Vue.set(state, 'section', {})
    },
    clearDropdowns(state) {
        Vue.set(state, 'dropdowns', [])
    },
    clearNewStaticSite(state) {
        Vue.set(state, 'newStaticSite', [])
    },
    setDropdownsState(state, s) {
        Vue.set(state, 'dropdownsState', s)
    },
    setSitesState(state, s) {
        Vue.set(state, 'sitesState', s)
    },
    setSectionsState(state, s) {
        Vue.set(state, 'sectionsState', s)
    },
}
